export function Stat({ label, value }: { label: string; value: number | string | undefined }) {
  return (
    <div className="rounded border bg-gray-50 p-3">
      <p className="text-xs uppercase text-gray-500">{label}</p>
      <p className="text-lg font-semibold">{value ?? '-'}</p>
    </div>
  );
}
